import React, { useEffect } from "react";
import { Row, Col, Card, Typography, Input, Button, Form, message } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import styled from "styled-components";
import containership from "../image/containership.png";
import { useMediaQuery } from "@mui/material";
import {
  DoubleLeftOutlined,
  PhoneOutlined,
  MailOutlined,
  HomeOutlined,
  SendOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link, useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const StyledContainer = styled.div`
  width: 90%;
  margin: 0 auto;
  padding: 50px 0;
  position: relative;

  .subscribe-section {
    display: flex;
    flex-direction: column;
    // align-items: center;
    // text-align: center;
    background-color: #b5b5b5a3;
    padding: 10px;
    border-radius: 12px;

    h2 {
      font-size: 2.5rem;
      font-weight: bold;
      margin-bottom: 10px;
    }

    p {
      color: #021433;
      font-size: 1rem;
      max-width: 500px;
      margin-bottom: 20px;
    }
  }

  .input-container {
    display: flex;
    align-items: center;
    background: #ffffff5c;
    padding: 5px;
    border-radius: 8px;
    border: 1px solid #ddd;
    width: 100%;
    max-width: 500px;
  }

  .ant-input {
    border: none;
    box-shadow: none;
    font-size: 1rem;
    flex: 1;
  }

  .subscribe-btn {
    background-color: #00a76f;
    border: none;
    color: #fff;
    font-size: 1.2rem;
    border-radius: 5px;
    padding: 0 15px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 768px) {
    .subscribe-section {
      // text-align: center;
    }

    .input-container {
      margin-top: 15px;
      justify-content: center;
    }
  }
`;
const AddressWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 4px;
  }

  label {
    color: white;
    font-size: 17px;
    font-family: monospace;
    word-break: break-word;
  }

  .address-title {
    display: flex;
    align-items: center;
    font-weight: 400;
    flex-shrink: 0;
    white-space: nowrap;
  }

  .address-text {
    flex: 1;
    min-width: 0;
    white-space: normal;
  }
`;

const Section7 = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  useEffect(() => {
    AOS.init({ duration: 3000 }); // Initialize AOS with a duration of 1000ms
  }, []);
  const navigate = useNavigate(); // React Router navigation function

  const handleRedirect = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate("/contact"); // Redirect to the contact page
  };

  return (
    <StyledContainer>
      <br />
      <motion.div
        // whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 1.0 }}
        className="motion-div"
      >
        <img
          src={containership}
          data-aos="fade-right"
          style={{
            position: "absolute",
            right: "0px",
            top: "0px",
            width: isMobile ? "100%" : "44%",
          }}
        />
      </motion.div>
      <Row justify="center" align="middle">
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 1.0 }}
            className="motion-div"
            data-aos="fade-up"
          >
            <div className="">
              <Card
                title="Contact Us"
                style={{
                  maxWidth: 800,
                  margin: "0 auto",
                  borderRadius: 12,
                  color: "white",
                  background:
                    "linear-gradient( 90deg, rgb(3, 13, 51), rgb(0, 53, 55), rgb(0 0 0) )",
                }}
                headStyle={{
                  color: "white", // 👈 this makes the title text white
                  fontSize: 25,
                  borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
                }}
                bordered={false}
              >
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24}>
                    <PhoneOutlined
                      style={{
                        marginRight: 8,
                        color: "white",
                        fontSize: 18,
                        transform: "rotate(105deg)",
                      }}
                    />
                    <Text
                      style={{
                        color: "white",
                        fontSize: 17,
                        fontWeight: 400,
                        fontFamily: "monospace",
                      }}
                    >
                      Call us:
                    </Text>
                    {/* <br /> */} &nbsp;
                    <Text>
                      <a
                        href="tel:+919284382353"
                        style={{
                          color: "white",
                          fontSize: 17,
                          fontFamily: "monospace",
                        }}
                      >
                        +919284382353
                      </a>
                    </Text>
                  </Col>

                  <Col xs={24} sm={24}>
                    <MailOutlined
                      style={{ marginRight: 8, color: "white", fontSize: 17 }}
                    />
                    <Text
                      style={{
                        color: "white",
                        fontSize: 17,
                        fontWeight: 400,
                        fontFamily: "monospace",
                      }}
                    >
                      Email:{" "}
                    </Text>
                    {/* <br /> */}&nbsp;
                    <Text>
                      <a
                        href="mailto:nexuswealthservices@gmail.com"
                        style={{
                          color: "white",
                          fontSize: 17,
                          textDecoration: "none",
                          fontFamily: "monospace",
                        }}
                      >
                        nexuswealthservices@gmail.com
                      </a>
                    </Text>
                  </Col>

                  <Col  xs={24} sm={24}>
                    <AddressWrapper>
                      <label className="address-title">
                        <EnvironmentOutlined
                          style={{
                            marginRight: 8,
                            color: "white",
                            fontSize: 17,
                            marginTop: 4,
                          }}
                        />
                        Address:
                      </label>
                     
                      <label className="address-text">
                        365/B Plot No-1, Mehul Garden, Opposite to Priya
                        Darshani Colony, Karvir Kolhapur Maharashtra, Uchagaon
                        416005.
                      </label>
                    </AddressWrapper>
                  </Col>
                </Row>
              </Card>
            </div>
          </motion.div>
        </Col>
        <br />
        <br />
        <Col xs={24} sm={24} md={24} lg={10} xl={10}></Col>
        {/* <Col
          xs={24}
          sm={24}
          md={24}
          lg={10}
          xl={10}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div
            className="input-container"
            style={{
              display: "flex",
              gap: "10px",
              width: "100%",
              marginTop: "37px",
            }}
          >
           
            <div style={{ flex: 1 }}>
              <Input
                placeholder="Enter email address..."
                size="large"
                style={{ width: "100%", cursor: "pointer" }}
                onClick={handleRedirect} 
              />
            </div>

           
            <Button
              className="subscribe-btn"
              icon={<DoubleRightOutlined />}
              style={{ minWidth: "50px" }}
              onClick={handleRedirect} 
            />
          </div>
        </Col> */}
      </Row>
    </StyledContainer>
  );
};

export default Section7;
